import { render, staticRenderFns } from "./AgentSuggestionPrompts.vue?vue&type=template&id=6f341658&scoped=true"
import script from "./AgentSuggestionPrompts.vue?vue&type=script&lang=js"
export * from "./AgentSuggestionPrompts.vue?vue&type=script&lang=js"
import style0 from "./AgentSuggestionPrompts.vue?vue&type=style&index=0&id=6f341658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f341658",
  null
  
)

export default component.exports